// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iyYG","questions":"styles_questions__2_VrO","footer":"styles_footer__xyl1R"};